<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="11.5" stroke="#000"/>
  <path fill="#000" d="M12.667 14.5C13.12 11.715 16 12.253 16 9.737 16 8.076 14.463 7 12.35 7 9.711 7 8.174 8.598 8 10.766h1.59c.157-1.567 1.082-2.563 2.585-2.563 1.31 0 2.06.632 2.06 1.66 0 1.931-2.756 1.41-2.983 4.637h1.415zm-1.75 2.5h1.834v-1.646h-1.834V17z"/>
  <path fill="#000" d="M12.751 17h-1.834v-1.646h1.834V17z"/>
</svg>
